<nb-card class="dialog" [nbSpinner]="loading">
  <nb-card-header class="header">
    <morva-icons
      class="close-cross"
      icon="close"
      (click)="closeDialog()"
    ></morva-icons>
    <p data-testid="management-database-header-text" class="header-text" *ngIf="type === 'CreateSqlServer'">Microsoft SQL Server</p>
    <p class="header-text" *ngIf="type === 'EditSqlServer'">ویرایش تنظیمات Microsoft SQL Server</p>
    <p class="header-text" *ngIf="type === 'ReplaceSqlServer'">ویرایش داده Microsoft SQL Server</p>
    <p class="header-text" *ngIf="type === 'CreateOracle'">Oracle</p>
    <p class="header-text" *ngIf="type === 'EditOracle'">ویرایش تنظیمات Oracle</p>
  </nb-card-header>

  <nb-card-body class="body">
    <tart-connection-form [configuration]="configuration"
                          [connections]="connections"
                          [connection]="connection"
                          [dataSource]="dataSource"
                          [connectionTables]="connectionTables"
                          (validatorChange)="checkValidator($event)"
                          (valueChanges)="formValueChanges($event)"
                          (connectionTypeChanges)="onConnectionTypeChange($event)"
                          (selectedConnection)="loadConnectionTables($event)"></tart-connection-form>
    <morva-linear-notifiction
      class="mt-3 d-block"
      *ngIf="dataSource?.isIncremental"
      [message]="'توجه! تنظیمات تعداد ردیف بارگذاری با به‌روزرسانی تدریجی مغایرت دارد و اعمال نمی‌شود.'"
      [messageType]="'warning'"
      [themeType]="'v2'"
    >
    </morva-linear-notifiction>
    <ng-container *ngIf="selectedConnectionType && selectedConnectionType!==connection?.connectionType && (type === 'EditSqlServer' || type === 'EditOracle' || type === 'ReplaceSqlServer')">
      <morva-linear-notifiction
        class="mt-3 d-block"
        [message]="'توجه! هرگونه مغایرت در نام و نوع ستون‌ها منجر به حذف ستون می‌شود.'"
        [messageType]="'warning'"
        [themeType]="'v2'"
      >
      </morva-linear-notifiction>
      <morva-linear-notifiction
        class="d-block"
        [message]="'توجه! همه داشبوردهای منبع‌ داده فعلی طبق منبع‌ داده جدید به‌روز می‌شوند.'"
        [messageType]="'warning'"
        [themeType]="'v2'"
      >
      </morva-linear-notifiction>
    </ng-container>
  </nb-card-body>

  <nb-card-footer class="d-flex justify-content-end footer">
    <button *ngIf="type === 'EditSqlServer' || type === 'EditOracle' || type === 'ReplaceSqlServer' " nbButton
            class="cancel-button"
            (click)="closeDialog()">انصراف
    </button>
    <button nbButton data-testid="confirm-button" class="confirm-button" [disabled]="!validForm || !formValues"
            [nbSpinner]="submitState === 'submitting'"
            (click)="submit()">{{(type === 'CreateSqlServer' || type === 'CreateOracle') ? 'بارگذاری' : 'ذخیره'}}</button>
  </nb-card-footer>
</nb-card>
